import { createSelector } from 'reselect';
import getMenu from './getMenu';
import { getChoiceSetDiscountConfig } from './config';
import adjustChoiceSetMaxForQuantityDiscount from '../utils/ordering/adjustChoiceSetMaxForQuantityDiscount';
import getUserUnderage from './getUserUnderage';
import { filterAlcoholicItemsFromChoiceSet } from '../utils/ordering/filterAlcoholic';

export default createSelector(
  [getMenu, getChoiceSetDiscountConfig, getUserUnderage],
  (menu, choiceSetDiscountConfig, isUserUnderage) => {
    if (!menu?.choiceSets) {
      return {};
    }

    if (!choiceSetDiscountConfig || !choiceSetDiscountConfig.choiceSetKey) {
      const filteredChoiceSets = { ...menu.choiceSets };

      if (isUserUnderage) {
        Object.entries(menu.choiceSets).forEach(([key, choiceSet]) => {
          filteredChoiceSets[key] =
            filterAlcoholicItemsFromChoiceSet(choiceSet);
        });
      }

      return filteredChoiceSets;
    }

    const { choiceSetKey } = choiceSetDiscountConfig;

    // Iterate over choiceSets (assuming it's an object)
    return Object.entries(menu.choiceSets).reduce((acc: any, [key, cs]) => {
      acc[key] = adjustChoiceSetMaxForQuantityDiscount(
        cs as ValidatedChoiceSet,
        choiceSetKey,
        1,
      );

      if (isUserUnderage) {
        acc[key] = filterAlcoholicItemsFromChoiceSet(acc[key]);
      }

      return acc;
    }, {});
  },
);
